@if (isVisible()) {
  <avs-message type="warning">
    <div class="flex flex-1 justify-between">
      <div class="flex items-center">
        <span>
          You have to enable two-factor authentication during the next
          <strong>{{ daysRemaining() }}</strong>
          days, or you'll be locked out of the system.
        </span>
      </div>
      <div class="flex items-center">
        <button
          (click)="enable()"
          matButton="outlined"
        >
          Enable
        </button>
        <button
          class="ml-4"
          (click)="dismiss()"
        >
          <i class="icon-close"></i>
        </button>
      </div>
    </div>
  </avs-message>
}
